import React, { useEffect, useState } from "react";
import { min } from "../../utils";
import { people, planning, what, who } from "../../utils/images";
import "./about.scss";

const About = () => {
	const countText = ["Members", "Events", "Working Days"];
	const [counts, setCounts] = useState([0, 0, 0]);
	useEffect(() => {
		window.addEventListener("scroll", () => {
			if (window.scrollY > 1300) {
				const interval = setInterval(() => {
					setCounts((p) => [
						min(p[0] + 1, 65),
						min(p[1] + 1, 5),
						min(p[2] + 1, 1095),
					]);
				}, 100);
				return () => clearInterval(interval);
			}
		});
	}, []);
	const faqs = [
		{
			question: "What is EPMOC?",
			answer: `EPMOC is an organization, the managing society of IIIT Una which deals with the planning and management of all the events of the college.`,
		},
		{
			question: "How to get into EPMOC?",
			answer: `Every year, freshman interviews are conducted with all the required manner. One can register through the website by going on the "Apply Now" section.`,
		},
		{
			question: "What are the skills required to join EPMOC?",
			answer: `You have to be a team member and passionate about your work and enthusiastic towards the position. You should be a good listener and a good hand of the`,
		},
		{
			question: "What could be the benefits in being in EPMOC?",
			answer: `You will learn to deal with various types of work and time management and also get a chance to work on various events. Also you can get various merchandise inside the club.`,
		},
		{
			question: "How does EPMOC enhance your career?",
			answer: `It brings a mindset to work as a team and teaches you the time management and team management. It gives you various project works which will be useful for the resume too.`,
		},
	];

	return (
		<>
			<main className="about">
				<section className="about-card">
					<div className="about-card-image">
						<img src={who} alt="who" />
					</div>
					<div className="about-card-content">
						<h1 className="about-card-content-title">Who we are</h1>
						<div className="about-card-content-text">
							<p>
								This club focuses on the cultural development of
								the institute as well as bringing the institute
								to the outside world. Engineering colleges, be
								it IITs, NITs, or other IIITs are known for
								their placements and cultural footprints, we
								want to work on both for the all-round
								development of the institute.
							</p>
							<p>
								Club members aim to foster an inclusive and
								collaborative atmosphere among students.
								Students will have the opportunity to showcase
								their soft skills through organizing events from
								different domains.
							</p>
						</div>
					</div>
				</section>
				<section className="about-card">
					<div className="about-card-image">
						<img src={what} alt="what" />
					</div>
					<div className="about-card-content">
						<h1 className="about-card-content-title">
							What do we do?
						</h1>
						<div className="about-card-content-text">
							<p>
								There are some events that we run exclusively,
								and there are also some that we do in
								collaboration with other clubs. Additionally,
								EPMOC works to maintain a connection between
								students and college alumni through social
								networks. In the early lockdown days, EPMOC
								hosted online events like "War of Words", a
								debate competition, and "Best Entertainer," an
								open mic.
							</p>
							<p>
								Furthermore, it has held a farewell session with
								the recently graduated class, referred to as
								"Yaariyan", and it is continuing to work on a
								series of interviews with students who have
								excelled at their field of study known as
								"Safarnama." These are annually recurring
								events.
							</p>
						</div>
					</div>
				</section>
				<section className="about-card">
					<div className="about-card-image">
						<img src={planning} alt="planning" />
					</div>
					<div className="about-card-content">
						<h1 className="about-card-content-title">
							What we are planning
						</h1>
						<div className="about-card-content-text">
							<p>
								Our future aspirations include organising larger
								events and various competitions, we intend to
								expand our ability and domains. In addition to
								the institute's first-ever e-sport tournament,
								we also desire to host its first culture event.
								At the moment, we are still chalking things out
								for the cultural event. Once the infrastructures
								are in place, we will conduct sports events soon
							</p>
						</div>
					</div>
				</section>
			</main>
			<main
				className="about"
				style={{
					backgroundColor: "var(--black)",
					padding: 0,
				}}
			>
				<section
					className="about-window"
					style={{
						backgroundImage: `url(${people})`,
					}}
				>
					{counts.map((count, i) => (
						<div className="about-window-card" key={i}>
							<div className="about-window-card-count">
								{count}
							</div>
							<div className="about-window-card-text">
								{countText[i]}
							</div>
						</div>
					))}
				</section>
				<section className="about-faqs">
					<div className="about-faqs-head">
						<h1
							style={{
								color: "var(--bgcolor)",
							}}
						>
							FAQs
						</h1>
					</div>
					<div className="about-faqs-body">
						<p
							style={{
								fontSize: "1.25rem",
							}}
						>
							<div class="tabs">
								{faqs.map((faq, id) => (
									<div class="tab" key={id}>
										<input
											type="checkbox"
											id={`chck${id}`}
										/>
										<label
											class="tab-label"
											for={`chck${id}`}
										>
											{faq.question}
										</label>
										<div class="tab-content">
											<span>
												Question: {faq.question}
											</span>
											<span>Answer: {faq.answer}</span>
										</div>
									</div>
								))}
							</div>
						</p>
					</div>
				</section>
			</main>
		</>
	);
};

export default About;
